import * as React from 'react';
import { SearchBar } from '@/components/common/SearchBar';
import type { ContactSearchProps } from '../types';

/**
 * ContactSearch Component
 * Refactored to use the shared SearchBar for consistency (DRY).
 */
export const ContactSearch: React.FC<ContactSearchProps> = ({ value, onChange }) => (
  <div className='mb-6'>
    <SearchBar
      value={value}
      onChange={onChange}
      placeholder='Search chat'
      className='bg-white xl:w-[368px] xl:bg-gray-150'
    />
  </div>
);
